import React, { useState } from "react";
import Button from "../Atoms/Button";
import { useAppSelector } from "Redux/hooks";
import { selectNewBeEvents } from "Redux/UserSlice";

/*
  @function ElementCards
  cards to edit elements
  @params title {string} - title to show
  @params editor {React.Node} - editor
  @params id {string} - id of element
  @params onDelete {function} - function on delete
  @returns {React.Node}
*/
export default function ElementCards({
  title = "",
  editor,
  id,
  onSave,
  onDelete,
}: {
  title: string;
  editor: React.ReactNode;
  id: string;
  onSave: () => void;
  onDelete: () => void;
}) {
  const [showing, setShowing] = useState(false);
  const newBeEvents = useAppSelector(selectNewBeEvents);

  return (
    <div
      className="flex justify-between border-2 border-black rounded-full p-6"
      onClick={() => (!showing ? setShowing(true) : null)}
    >
      {showing ? (
        <Opened
          editor={editor}
          onCollapse={() => {
            setShowing(false);
          }}
          onDelete={onDelete}
        />
      ) : (
        <Closed title={title} />
      )}
      {newBeEvents[id] !== undefined && (
        <Button label="SAVE" onClick={onSave} />
      )}
    </div>
  );
}

/*
  @function Closed
  render closed card
  @param title {string} - title to render
  @returns {React.Node}
*/
function Closed({ title = "" }: { title: string }): React.ReactElement {
  return (
    <>
      <h3>{title}</h3>
    </>
  );
}

/*
  @function Opened
  render opened card
  @param editor {React.Node} - editor for the element
  @returns {React.Node}
*/
function Opened({
  editor,
  onCollapse,
  onDelete,
}: {
  editor: React.ReactNode;
  onCollapse: () => void;
  onDelete: () => void;
}) {
  return (
    <div className="flex flex-row m-auto">
      <div className="m-auto flex flex-col ">{editor}</div>
      <Button
        className="h-24 m-auto"
        onClick={() => onCollapse()}
        label="collapse"
      />
      <Button className="h-24 m-auto ml-8" label="REMOVE" onClick={onDelete} />
    </div>
  );
}
